module.exports = __webpack_public_path__ + "static/media/depoimento-curso-sushi-3.845513e6.png";